<template>
	<div>
	<b-row v-if="problems.length > 0"><b-col>
		<b-table striped hover :fields="fields" :items="flatProblems()" stacked="md" id="problems-table">
			<template v-slot:cell(delete-action)="data">
		  			<span :id="'delete-problem-' + data.item.problem_id + data.item.person_id" @click="deleteItem(data.item.problem_id, data.item.person_id)">
		  				<b-icon icon="trash2-fill" scale="1.6"></b-icon>
		  			</span>
	  		</template>
		</b-table>
	</b-col></b-row>
	<b-row align-h="center">
			<b-col sm="*">
			 	<b-button variant="info" id="problems-new-problem" @click="$router.push({ name: 'PersonSelector' })">Kattintson ide a problémák kiválasztásához!</b-button>*
			 </b-col>
	</b-row>
	</div>
</template>

<script>
export default {
	name: 'problems',
	data() {
		return {
			fields:[
				{
				 label: 'Személy',
				 key: 'person_name'
				},
				{
					label: 'azonosító',
					key: 'person_id'
				},
				{
					label: 'Probléma',
					key: 'problem_name'
				},
				{
					label: 'azonosító',
					key: 'problem_id'
				},
				{
					label: 'Törlés',
					key: 'delete-action'
				}
			],
			items: []
		}
	},
	computed: {
		problems() {
			return this.$store.state.form.problems || []
		}
	},
	methods: {
		deleteItem(problemId, personId) {
			this.$store.commit('deleteProblem', { problemId, personId })
		},
		flatProblems() {
			return this.problems.map(problem => {
				return {
					person_id: problem.person?.id,
					person_name: problem.person?.name,
					problem_id: problem.problem?.id,
					problem_name: problem.problem?.name
				}})
		}
	}
}
</script>
<style scoped>

.delete-icon {
	cursor: pointer;
}

</style>